import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

export const StyledCadenceFunctionBadgeIcon = styled.span<{ $isRotated?: boolean }>`
    display: inline-flex;

    ${SWReactIcons} {
        transform: ${({ $isRotated }) => ($isRotated ? "rotate(180deg)" : "none")};
    }
`;
